import React from "react";
import CircleIcon from "./CircleIcon";
import telegram from "../resource/telegram.jpg";
import linkedin from "../resource/702300.png";
import github from "../resource/GitHub-Mark-ea2971cee799.png";

import "./CircleIconHolder.css";

function CircleIconHolder(props) {
  const handleTeleClick = () => {
    window.open("https://t.me/zhmasternus", "_blank");
  };
  const handleLinkedClick = () => {
    window.open("https://www.linkedin.com/in/cheng-zihao-870a77246/", "_blank");
  };
  const handleGitClick = () => {
    window.open("https://github.com/chengzihao123", "_blank");
  };
  return (
    <div className="header">
      <CircleIcon image={telegram} onclick={handleTeleClick} />
      <CircleIcon image={linkedin} onclick={handleLinkedClick} />
      <CircleIcon image={github} onclick={handleGitClick} />
    </div>
  );
}
export default CircleIconHolder;
